import React from 'react'

const Merchant = () => {
  return (
    <div>Merchant</div>
  )
}

export default Merchant;
